﻿const axios = require('axios');
import * as odpUtils from '../integrations/ODP/utils';
import InputFloatLabel from '@components/input-labels';
class Register {
    Init() {
        var inst = this;

        $('.jsUsersStep1SignupBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.signupStep1($(this));
            });
            $('jsUsersStep1SignupBtn').scrollTop(0);

        });

        $('.jsUsersStep2SignupBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.signupStep2($(this));
            });
        });

        $('.jsUsersSignupBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.signup($(this));
            });
        });

        $('.jsUsersSignupMarketingBtn').each(function (i, e) {
            $(e).click(function (event) {
                event.preventDefault();
                inst.signupmarketingaccount($(this));
            });
        });

        $('.BillingCountryChanged').each(function (i, e) {
            $(e).change(function (event) {
                //event.preventDefault();
                inst.BillingCountryChangedIndex($(this));
            });
        });

        $('.ShippingCountryChanged').each(function (i, e) {
            $(e).change(function (event) {
                //event.preventDefault();
                inst.ShippingCountryChangedIndex($(this));
            });
        });
        $('#RegisterAccountViewModel_DuplicateBilling').each(function (i, e) {
            $(e).change(function (event) {
                inst.sameAsBillingAddress();
            });
        });
    }

    convertToJsonObject(arrayData) {
        var indexed_array = {};

        $.map(arrayData, function (n, i) {
            indexed_array[n['name']] = n['value'];
        });

        return indexed_array;
    }

    signupStep1(e) {
        let form = $(e).closest("form")[0];
        let bodyFormData1 = new FormData();

        bodyFormData1.set('FirstName', $("#RegisterAccountViewModel_FirstName", form).val());
        bodyFormData1.set('LastName', $("#RegisterAccountViewModel_LastName", form).val());
        bodyFormData1.set('Email', $("#RegisterAccountViewModel_Email", form).val());
        bodyFormData1.set('Company', $("#RegisterAccountViewModel_Company", form).val());
        bodyFormData1.set('PhoneNumber', $("#RegisterAccountViewModel_PhoneNumber", form).val());
        bodyFormData1.set('Country', $('select[name="RegisterAccountViewModel.Country"]', form).val());
        bodyFormData1.set('CustomerNumber', $('#RegisterAccountViewModel_CustomerNumber', form).val());
        bodyFormData1.set('PrimaryProductCatalog', $('select[name="RegisterAccountViewModel.PrimaryProductCatalog"]', form).val());
        bodyFormData1.set('PreferredLanguage', $('select[name="RegisterAccountViewModel.PreferredLanguage"]', form).val());
        bodyFormData1.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());

        if ($('#RegisterAccountViewModel_DistributionChannel').length > 0) {
            bodyFormData1.set('DistributionChannel', $('#RegisterAccountViewModel_DistributionChannel').val());
        }

        if ($('#RegisterAccountViewModel_DistributionChannelRequired').length > 0) {
            bodyFormData1.set('DistributionChannelRequired', $('#RegisterAccountViewModel_DistributionChannelRequired').val());
        }

        if ($('#RegisterAccountViewModel_SalesRepresentative').length > 0) {
            bodyFormData1.set('SalesRepresentative', $('#RegisterAccountViewModel_SalesRepresentative').val());
        }

        if ($('#RegisterAccountViewModel_SalesRepresentativeRequired').length > 0) {
            bodyFormData1.set('SalesRepresentativeRequired', $('#RegisterAccountViewModel_SalesRepresentativeRequired').val());
        }

        $('.loading-box').show();
        axios({
            method: 'post',
            url: form.action,
            data: bodyFormData1,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response1) {
                if (response1.data) {
                    if (response1.data.success) {
                        $(".register").toggle();
                        $(".register-confirmation").toggle();
                    }
                    else {
                        var errorMessage = document.getElementById('login-signup-errormessage');

                        //For step - 1
                        var firstNameError = document.getElementById('FirstNameError');
                        var lastNameError = document.getElementById('LastNameError');
                        var emailError = document.getElementById('EmailError');
                        var countryError = document.getElementById('CountryError');
                        var companyError = document.getElementById('CompanyError');
                        var phoneNumberError = document.getElementById('PhoneNumberError');

                        var distributionChannelError = document.getElementById('DistributionChannelError');
                        var salesRepresentativeError = document.getElementById('SalesRepresentativeError');

                        if (errorMessage) {
                            errorMessage.innerText = '';

                            for (var error in response1.data.errors) {
                                //for step - 1 basic information 
                                if (response1.data.errors[error].key === "FirstName") {
                                    firstNameError.innerText = response1.data.errors[error].value;
                                    $('#FirstNameError').parent().addClass('form-error');
                                }
                                if (response1.data.errors[error].key === "LastName") {
                                    lastNameError.innerText = response1.data.errors[error].value;
                                    $('#LastNameError').parent().addClass('form-error');
                                }
                                if (response1.data.errors[error].key === "Email") {
                                    emailError.innerText = response1.data.errors[error].value;
                                    $('#EmailError').parent().addClass('form-error');
                                }
                                if (response1.data.errors[error].key === "Country") {
                                    countryError.innerText = response1.data.errors[error].value;
                                    $('#CountryError').parent().addClass('form-error');
                                }
                                if (response1.data.errors[error].key === "Company") {
                                    companyError.innerText = response1.data.errors[error].value;
                                    $('#CompanyError').parent().addClass('form-error');
                                }
                                if (response1.data.errors[error].key === "PhoneNumber") {
                                    phoneNumberError.innerText = response1.data.errors[error].value;
                                    $('#PhoneNumberError').parent().addClass('form-error');
                                }

                                //RESET for step -1 
                                if (firstNameError.innerText === '') {
                                    $('#FirstNameError').parent().removeClass('form-error');
                                }
                                if (lastNameError.innerText === '') {
                                    $('#LastNameError').parent().removeClass('form-error');
                                }

                                if (emailError.innerText === '') {
                                    $('#EmailError').parent().removeClass('form-error');
                                }

                                if (countryError.innerText === '') {
                                    $('#CountryError').parent().removeClass('form-error');
                                }

                                if (companyError.innerText === '') {
                                    $('#CompanyError').parent().removeClass('form-error');
                                }

                                if (phoneNumberError.innerText === '') {
                                    $('#PhoneNumberError').parent().removeClass('form-error');
                                }

                                //
                                if (distributionChannelError && distributionChannelError.innerText === '') {
                                    $('#DistributionChannelError').parent().removeClass('form-error');
                                }

                                if (salesRepresentativeError && salesRepresentativeError.innerText === '') {
                                    $('#SalesRepresentativeError').parent().removeClass('form-error');
                                }
                                
                                if (response1.data.errors[error].key === undefined ||
                                    response1.data.errors[error].key === '') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response1.data.errors[error] + '<br />');
                                }

                            }
                        }
                    }
                }
                else {
                    window.location.href = '/';
                }
            })
            .catch(function (response1) {
                var errorPanel = document.getElementById('login-signup-errormessage');
                errorPanel.innerText = response1;
                errorPanel.style.display = "block";
            })
            .finally(function () {
                $('.loading-box').hide();
                if ($('.form-error-information').text() === "" && $.trim($('#RegisterAccountViewModel_FirstName').val()) != '') {
                    $('#stepOne').hide();
                    $("#stepTwo").show();
                    $(".stepNumber").html("2");
                    $('#BasicInfo').removeClass("design-tool__step-info active");
                    $('#BasicInfo').addClass("design-tool__step-info hidden");
                    $('#BillingInfo').addClass("design-tool__step-info active");
                    $("#step1").removeClass("design-tool__step active");
                    $("#step1").addClass("design-tool__step complete");
                    $("#step1").addClass("design-tool__step check");
                    $("#step2").removeClass("design-tool__step complete");
                    $("#step2").addClass("design-tool__step active");
                }
            });
    }

    signupStep2(e) {
        let form = $(e).closest("form")[0];
        let bodyFormData2 = new FormData();

        bodyFormData2.set('FirstName', $("#RegisterAccountViewModel_FirstName", form).val());
        bodyFormData2.set('LastName', $("#RegisterAccountViewModel_LastName", form).val());
        bodyFormData2.set('Email', $("#RegisterAccountViewModel_Email", form).val());
        bodyFormData2.set('Company', $("#RegisterAccountViewModel_Company", form).val());
        bodyFormData2.set('PhoneNumber', $("#RegisterAccountViewModel_PhoneNumber", form).val());
        bodyFormData2.set('Country', $('select[name="RegisterAccountViewModel.Country"]', form).val());
        bodyFormData2.set('CustomerNumber', $('#RegisterAccountViewModel_CustomerNumber', form).val());
        bodyFormData2.set('PrimaryProductCatalog', $('select[name="RegisterAccountViewModel.PrimaryProductCatalog"]', form).val());
        bodyFormData2.set('PreferredLanguage', $('select[name="RegisterAccountViewModel.PreferredLanguage"]', form).val());


        if ($('#RegisterAccountViewModel_SalesRepresentative').length > 0) {
            bodyFormData2.set('SalesRepresentative', $('#RegisterAccountViewModel_SalesRepresentative').val());
        }

        if ($('#RegisterAccountViewModel_DistributionChannel').length > 0) {
            bodyFormData2.set('DistributionChannel', $('#RegisterAccountViewModel_DistributionChannel').val());
        }

        if ($('#RegisterAccountViewModel_SalesRepresentativeRequired').length > 0) {
            bodyFormData2.set('SalesRepresentativeRequired', $('#RegisterAccountViewModel_SalesRepresentativeRequired').val());
        }

        if ($('#RegisterAccountViewModel_DistributionChannelRequired').length > 0) {
            bodyFormData2.set('DistributionChannelRequired', $('#RegisterAccountViewModel_DistributionChannelRequired').val());
        }

        InputFloatLabel.Rebind();

        bodyFormData2.set('BillingAddress.Line1', $("#RegisterAccountViewModel_BillingAddress_Line1", form).val());
        bodyFormData2.set('BillingAddress.Line2', $("#RegisterAccountViewModel_BillingAddress_Line2", form).val());
        bodyFormData2.set('BillingAddress.City', $("#RegisterAccountViewModel_BillingAddress_City", form).val());

        //passing correct state code to back end
        if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'USA') {
            bodyFormData2.set('BillingAddress.StateProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.StateProvinceCode"]', form).val());
            bodyFormData2.set('BillingAddress.ProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.StateProvinceCode"]', form).val());
        }
        else if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'CAN') {
            bodyFormData2.set('BillingAddress.StateProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.ProvinceCode"]', form).val());
            bodyFormData2.set('BillingAddress.ProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.ProvinceCode"]', form).val());
        }
        else {
            bodyFormData2.set('BillingAddress.StateProvinceCode', $("#RegisterAccountViewModel_BillingAddress_StateProvinceName", form).val());
            bodyFormData2.set('BillingAddress.ProvinceCode', $("#RegisterAccountViewModel_BillingAddress_StateProvinceName", form).val());
            if ($("#RegisterAccountViewModel_BillingAddress_StateProvinceName", form).val() === "") {
                bodyFormData2.set('BillingAddress.StateProvinceCode', "NA-Not Applicable");
                bodyFormData2.set('BillingAddress.ProvinceCode', "NA-Not Applicable");
            }
        }


        bodyFormData2.set('BillingAddress.PostalCode', $("#RegisterAccountViewModel_BillingAddress_PostalCode", form).val());
        bodyFormData2.set('BillingAddress.CountryName', $('select[name="RegisterAccountViewModel.BillingAddress.CountryName"]', form).val());
        bodyFormData2.set('BillingAddress.PhoneNumber', $("#RegisterAccountViewModel_BillingAddress_PhoneNumber", form).val());

        bodyFormData2.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());

        $('.loading-box').show();
        axios({
            method: 'post',
            url: form.action,
            data: bodyFormData2,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response2) {
                if (response2.data) {
                    if (response2.data.success) {
                        $(".register").toggle();
                        $(".register-confirmation").toggle();
                    }
                    else {
                        var errorMessage = document.getElementById('login-signup-errormessage');

                        //For step - 2
                        var billingLine1Error = document.getElementById('BillingLine1Error');
                        var billingCityError = document.getElementById('BillingCityError');
                        var billingStateProvinceError = document.getElementById('BillingStateProvinceError');
                        var billingPostalCodeError = document.getElementById('BillingPostalCodeError');
                        var billingCountryError = document.getElementById('BillingCountryError');
                        var billingPhoneNumberError = document.getElementById('BillingPhoneNumberError');

                        if (errorMessage) {
                            errorMessage.innerText = '';
                            for (var error in response2.data.errors) {
                                //for step-2 bill address

                                if (response2.data.errors[error].key === "BillingAddress.Line1") {
                                    billingLine1Error.innerText = response2.data.errors[error].value;
                                    $('#BillingLine1Error').parent().addClass('form-error');
                                }
                                if (response2.data.errors[error].key === "BillingAddress.City") {
                                    billingCityError.innerText = response2.data.errors[error].value;
                                    $('#BillingCityError').parent().addClass('form-error');
                                }
                                if (response2.data.errors[error].key === "BillingAddress.StateProvinceCode") {
                                    billingStateProvinceError.innerText = response2.data.errors[error].value;
                                    $('#BillingStateProvinceError').parent().addClass('form-error');
                                }
                                if (response2.data.errors[error].key === "BillingAddress.PostalCode") {
                                    billingPostalCodeError.innerText = response2.data.errors[error].value;
                                    $('#BillingPostalCodeError').parent().addClass('form-error');
                                }
                                if (response2.data.errors[error].key === "BillingAddress.CountryName") {
                                    billingCountryError.innerText = response2.data.errors[error].value;
                                    $('#BillingCountryError').parent().addClass('form-error');
                                }
                                if (response2.data.errors[error].key === "BillingAddress.PhoneNumber") {
                                    billingPhoneNumberError.innerText = response2.data.errors[error].value;
                                    $('#BillingPhoneNumberError').parent().addClass('form-error');
                                }

                                //RESET for step -2 
                                if (billingLine1Error.innerText === '') {
                                    $('#BillingLine1Error').parent().removeClass('form-error');
                                }
                                if (billingCityError.innerText === '') {
                                    $('#BillingCityError').parent().removeClass('form-error');
                                }

                                if (billingStateProvinceError.innerText === '') {
                                    $('#BillingStateProvinceError').parent().removeClass('form-error');
                                }

                                if (billingPostalCodeError.innerText === '') {
                                    $('#BillingPostalCodeError').parent().removeClass('form-error');
                                }

                                if (billingCountryError.innerText === '') {
                                    $('#BillingCountryError').parent().removeClass('form-error');
                                }

                                if (billingPhoneNumberError.innerText === '') {
                                    $('#BillingPhoneNumberError').parent().removeClass('form-error');
                                }

                                if (response2.data.errors[error].key === undefined ||
                                    response2.data.errors[error].key === '') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response2.data.errors[error] + '<br />');
                                }

                            }
                        }
                    }
                }
                else {
                    window.location.href = '/';
                    signup(e);
                }
            })
            .catch(function (response2) {

                var errorPanel = document.getElementById('login-signup-errormessage');
                errorPanel.innerText = response2;
                errorPanel.style.display = "block";
            })
            .finally(function () {
                $('.loading-box').hide();
                if ($('.form-error-information').text() === "" && $.trim($('#RegisterAccountViewModel_BillingAddress_Line1').val()) != '') {
                    $('#stepTwo').hide();
                    $("#stepThree").show();
                    $(".stepNumber").html("3");
                    $('#BillingInfo').removeClass("design-tool__step-info active");
                    $('#BillingInfo').addClass("design-tool__step-info hidden");
                    $('#ShippingInfo').addClass("design-tool__step-info active");
                    $("#step2").removeClass("design-tool__step active");
                    $("#step2").addClass("design-tool__step complete");
                    $("#step2").addClass("design-tool__step check");
                    $("#step3").addClass("design-tool__step active");
                }
            });
    }

    signupmarketingaccount(e) {

        let form = $(e).closest("form")[0];
        let bodyFormData = new FormData();

        //For Step - 3
        bodyFormData.set('FirstName', $("#RegisterAccountViewModel_FirstName", form).val());
        bodyFormData.set('LastName', $("#RegisterAccountViewModel_LastName", form).val());
        bodyFormData.set('Email', $("#RegisterAccountViewModel_Email", form).val());
        bodyFormData.set('Company', $("#RegisterAccountViewModel_Company", form).val());
        bodyFormData.set('PhoneNumber', $("#RegisterAccountViewModel_PhoneNumber", form).val());
        bodyFormData.set('Country', $('select[name="RegisterAccountViewModel.Country"]', form).val());
        bodyFormData.set('ProductAccessLine', $('select[name="RegisterAccountViewModel.ProductAccessLine"]', form).val());
        bodyFormData.set('PreferredLanguage', $('select[name="RegisterAccountViewModel.PreferredLanguage"]', form).val());
        bodyFormData.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());


        $('.loading-box').show();
        axios({
            method: 'post',
            url: form.action,
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response) {
                if (response.data) {
                    if (response.data.success) {
                        $(".register").toggle();
                        $(".register-confirmation").toggle();
                    }
                    else {
                        var errorMessage = document.getElementById('login-signup-errormessage');

                        //For step - 1
                        var firstNameError = document.getElementById('FirstNameError');
                        var lastNameError = document.getElementById('LastNameError');
                        var emailError = document.getElementById('EmailError');
                        var countryError = document.getElementById('CountryError');
                        var companyError = document.getElementById('CompanyError');
                        var phoneNumberError = document.getElementById('PhoneNumberError');
                        var productAccessLineError = document.getElementById('ProductAccessLineError');

                        if (errorMessage) {
                            errorMessage.innerText = '';

                            for (var error in response.data.errors) {
                                //for step - 1 basic information 
                                if (response.data.errors[error].key === "FirstName") {
                                    firstNameError.innerText = response.data.errors[error].value;
                                    $('#FirstNameError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "LastName") {
                                    lastNameError.innerText = response.data.errors[error].value;
                                    $('#LastNameError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "Email") {
                                    emailError.innerText = response.data.errors[error].value;
                                    $('#EmailError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "Country") {
                                    countryError.innerText = response.data.errors[error].value;
                                    $('#CountryError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "Company") {
                                    companyError.innerText = response.data.errors[error].value;
                                    $('#CompanyError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "ProductAccessLine") {
                                    productAccessLineError.innerText = response.data.errors[error].value;
                                    $('#ProductAccessLineError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "PhoneNumber") {
                                    phoneNumberError.innerText = response.data.errors[error].value;
                                    $('#PhoneNumberError').parent().addClass('form-error');
                                }


                                //RESET for step -1 
                                if (firstNameError.innerText === '') {
                                    $('#FirstNameError').parent().removeClass('form-error');
                                }
                                if (lastNameError.innerText === '') {
                                    $('#LastNameError').parent().removeClass('form-error');
                                }

                                if (emailError.innerText === '') {
                                    $('#EmailError').parent().removeClass('form-error');
                                }

                                if (countryError.innerText === '') {
                                    $('#CountryError').parent().removeClass('form-error');
                                }

                                if (companyError.innerText === '') {
                                    $('#CompanyError').parent().removeClass('form-error');
                                }

                                if (productAccessLineError.innerText === '') {
                                    $('#ProductAccessLineError').parent().removeClass('form-error');
                                }

                                if (phoneNumberError.innerText === '') {
                                    $('#PhoneNumberError').parent().removeClass('form-error');
                                }


                                if (response.data.errors[error].key === undefined ||
                                    response.data.errors[error].key === '') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response.data.errors[error] + '<br />');
                                }

                            }
                        }
                    }
                }
                else {

                    window.location.href = '/';
                }
            })
            .catch(function (response) {
                var errorPanel = document.getElementById('login-signup-errormessage');
                errorPanel.innerText = response;
                errorPanel.style.display = "block";
            })
            .finally(function () {
                $('.loading-box').hide();
            });
    }

    signup(e) {

        let form = $(e).closest("form")[0];
        let bodyFormData = new FormData();

        //For Step - 3
        bodyFormData.set('FirstName', $("#RegisterAccountViewModel_FirstName", form).val());
        bodyFormData.set('LastName', $("#RegisterAccountViewModel_LastName", form).val());
        bodyFormData.set('Email', $("#RegisterAccountViewModel_Email", form).val());
        bodyFormData.set('Company', $("#RegisterAccountViewModel_Company", form).val());
        bodyFormData.set('PhoneNumber', $("#RegisterAccountViewModel_PhoneNumber", form).val());
        bodyFormData.set('Country', $('select[name="RegisterAccountViewModel.Country"]', form).val());
        bodyFormData.set('ProductAccessLine', $('select[name="RegisterAccountViewModel.ProductAccessLine"]', form).val());
        bodyFormData.set('PreferredLanguage', $('select[name="RegisterAccountViewModel.PreferredLanguage"]', form).val());

        if ($('#RegisterAccountViewModel_SalesRepresentative').length > 0) {
            bodyFormData.set('SalesRepresentative', $('#RegisterAccountViewModel_SalesRepresentative').val());
        }

        if ($('#RegisterAccountViewModel_DistributionChannel').length > 0) {
            bodyFormData.set('DistributionChannel', $('#RegisterAccountViewModel_DistributionChannel').val());
        }

        if ($('#RegisterAccountViewModel_SalesRepresentativeRequired').length > 0) {
            bodyFormData.set('SalesRepresentativeRequired', $('#RegisterAccountViewModel_SalesRepresentativeRequired').val());
        }

        if ($('#RegisterAccountViewModel_DistributionChannelRequired').length > 0) {
            bodyFormData.set('DistributionChannelRequired', $('#RegisterAccountViewModel_DistributionChannelRequired').val());
        }

        if ($("#RegisterAccountViewModel_CustomerNumber").length > 0) {
            bodyFormData.set('CustomerNumber', $('#RegisterAccountViewModel_CustomerNumber', form).val());
        }
        if ($('select[name="RegisterAccountViewModel.PrimaryProductCatalog"]').length > 0) {
            bodyFormData.set('PrimaryProductCatalog', $('select[name="RegisterAccountViewModel.PrimaryProductCatalog"]', form).val());
        }

        bodyFormData.set('BillingAddress.Line1', $("#RegisterAccountViewModel_BillingAddress_Line1", form).val());
        bodyFormData.set('BillingAddress.Line2', $("#RegisterAccountViewModel_BillingAddress_Line2", form).val());
        bodyFormData.set('BillingAddress.City', $("#RegisterAccountViewModel_BillingAddress_City", form).val());

        //passing correct state code to back end
        if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'USA') {
            bodyFormData.set('BillingAddress.StateProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.StateProvinceCode"]', form).val());
            bodyFormData.set('BillingAddress.ProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.StateProvinceCode"]', form).val());
        }
        else if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'CAN') {
            bodyFormData.set('BillingAddress.StateProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.ProvinceCode"]', form).val());
            bodyFormData.set('BillingAddress.ProvinceCode', $('select[name="RegisterAccountViewModel.BillingAddress.ProvinceCode"]', form).val());
        }
        else {
            bodyFormData.set('BillingAddress.StateProvinceCode', $("#RegisterAccountViewModel_BillingAddress_StateProvinceName", form).val());
            bodyFormData.set('BillingAddress.ProvinceCode', $("#RegisterAccountViewModel_BillingAddress_StateProvinceName", form).val());
            if ($("#RegisterAccountViewModel_BillingAddress_StateProvinceName", form).val() === "") {
                bodyFormData.set('BillingAddress.StateProvinceCode', "NA-Not Applicable");
                bodyFormData.set('BillingAddress.ProvinceCode', "NA-Not Applicable");
            }
        }

        bodyFormData.set('BillingAddress.PostalCode', $("#RegisterAccountViewModel_BillingAddress_PostalCode", form).val());
        bodyFormData.set('BillingAddress.CountryName', $('select[name="RegisterAccountViewModel.BillingAddress.CountryName"]', form).val());
        bodyFormData.set('BillingAddress.PhoneNumber', $("#RegisterAccountViewModel_BillingAddress_PhoneNumber", form).val());

        bodyFormData.set('DuplicateBilling', $('#RegisterAccountViewModel_DuplicateBilling', form).val());

        bodyFormData.set('ShippingAddress.Line1', $("#RegisterAccountViewModel_ShippingAddress_Line1", form).val());
        bodyFormData.set('ShippingAddress.Line2', $("#RegisterAccountViewModel_ShippingAddress_Line2", form).val());
        bodyFormData.set('ShippingAddress.City', $("#RegisterAccountViewModel_ShippingAddress_City", form).val());

        //passing correct state code to back end
        if ($("#RegisterAccountViewModel_ShippingAddress_CountryName option:selected").val() === 'USA') {
            bodyFormData.set('ShippingAddress.StateProvinceCode', $('select[name="RegisterAccountViewModel.ShippingAddress.StateProvinceCode"]', form).val());
            bodyFormData.set('ShippingAddress.ProvinceCode', $('select[name="RegisterAccountViewModel.ShippingAddress.StateProvinceCode"]', form).val());
        }
        else if ($("#RegisterAccountViewModel_ShippingAddress_CountryName option:selected").val() === 'CAN') {
            bodyFormData.set('ShippingAddress.StateProvinceCode', $('select[name="RegisterAccountViewModel.ShippingAddress.ProvinceCode"]', form).val());
            bodyFormData.set('ShippingAddress.ProvinceCode', $('select[name="RegisterAccountViewModel.ShippingAddress.ProvinceCode"]', form).val());
        }
        else {
            bodyFormData.set('ShippingAddress.StateProvinceCode', $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName", form).val());
            bodyFormData.set('ShippingAddress.ProvinceCode', $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName", form).val());
            if ($("#RegisterAccountViewModel_ShippingAddress_StateProvinceName", form).val() === "") {
                bodyFormData.set('ShippingAddress.StateProvinceCode', "NA-Not Applicable");
                bodyFormData.set('ShippingAddress.ProvinceCode', "NA-Not Applicable");
            }
        }

        bodyFormData.set('ShippingAddress.PostalCode', $("#RegisterAccountViewModel_ShippingAddress_PostalCode", form).val());
        bodyFormData.set('ShippingAddress.CountryName', $('select[name="RegisterAccountViewModel.ShippingAddress.CountryName"]', form).val());
        bodyFormData.set('ShippingAddress.PhoneNumber', $("#RegisterAccountViewModel_ShippingAddress_PhoneNumber", form).val());

        bodyFormData.set('__RequestVerificationToken', $("input[name=__RequestVerificationToken]", form).val());


        $('.loading-box').show();
        axios({
            method: 'post',
            url: form.action,
            data: bodyFormData,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
            .then(function (response) {
                if (response.data) {
                    if (response.data.success) {
                        $(".register").toggle();
                        $(".register-confirmation").toggle();

                        odpUtils.TrackRegister(response.data.email, response.data.siteUserId, response.data.customerContactId);
                        odpUtils.TrackCustomerInformation(
                            response.data.email, 
                            response.data.siteUserId, 
                            response.data.customerContactId,
                            response.data.salesOrg,
                            response.data.distChannel,
                            response.data.market)
                    }
                    else {
                        var errorMessage = document.getElementById('login-signup-errormessage');

                        //For step - 3
                        var shippingLine1Error = document.getElementById('ShippingLine1Error');
                        var shippingCityError = document.getElementById('ShippingCityError');
                        var shippingStateProvinceError = document.getElementById('ShippingStateProvinceError');
                        var shippingPostalCodeError = document.getElementById('ShippingPostalCodeError');
                        var shippingCountryError = document.getElementById('ShippingCountryError');
                        var shippingPhoneNumberError = document.getElementById('ShippingPhoneNumberError');

                        if (errorMessage) {
                            errorMessage.innerText = '';
                            for (var error in response.data.errors) {
                                //for step-3 ship address

                                if (response.data.errors[error].key === "ShippingAddress.Line1") {
                                    shippingLine1Error.innerText = response.data.errors[error].value;
                                    $('#ShippingLine1Error').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "ShippingAddress.City") {
                                    shippingCityError.innerText = response.data.errors[error].value;
                                    $('#ShippingCityError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "ShippingAddress.StateProvinceCode") {
                                    shippingStateProvinceError.innerText = response.data.errors[error].value;
                                    $('#ShippingStateProvinceError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "ShippingAddress.PostalCode") {
                                    shippingPostalCodeError.innerText = response.data.errors[error].value;
                                    $('#ShippingPostalCodeError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "ShippingAddress.CountryName") {
                                    shippingCountryError.innerText = response.data.errors[error].value;
                                    $('#ShippingCountryError').parent().addClass('form-error');
                                }
                                if (response.data.errors[error].key === "ShippingAddress.PhoneNumber") {
                                    shippingPhoneNumberError.innerText = response.data.errors[error].value;
                                    $('#ShippingPhoneNumberError').parent().addClass('form-error');
                                }

                                //RESET for step -3
                                if (shippingLine1Error.innerText === '') {
                                    $('#ShippingLine1Error').parent().removeClass('form-error');
                                }
                                if (shippingCityError.innerText === '') {
                                    $('#ShippingCityError').parent().removeClass('form-error');
                                }

                                if (shippingStateProvinceError.innerText === '') {
                                    $('#ShippingStateProvinceError').parent().removeClass('form-error');
                                }

                                if (shippingPostalCodeError.innerText === '') {
                                    $('#ShippingPostalCodeError').parent().removeClass('form-error');
                                }

                                if (shippingCountryError.innerText === '') {
                                    $('#ShippingCountryError').parent().removeClass('form-error');
                                }

                                if (shippingPhoneNumberError.innerText === '') {
                                    $('#ShippingPhoneNumberError').parent().removeClass('form-error');
                                }

                                if (response.data.errors[error].key === 'Register.ContactExist') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response.data.errors[error].value + '<br />');
                                }

                                if (response.data.errors[error].key === undefined || response.data.errors[error].key === '') {
                                    errorMessage.style.display = "block";
                                    $('#login-signup-errormessage').append(response.data.errors[error] + '<br />');
                                }
                            }
                        }
                    }
                }
                else {

                    window.location.href = '/';
                }
            })
            .catch(function (response) {

                var errorPanel = document.getElementById('login-signup-errormessage');
                errorPanel.innerText = response;
                errorPanel.style.display = "block";
            })
            .finally(function () {
                $('.loading-box').hide();
            });
    }

    ShippingCountryChangedIndex(e) {

        var vm = this;
        vm.RegisterAccountViewModel_ShippingAddress_StateProvinceCode = null;
        vm.RegisterAccountViewModel_ShippingAddress_ProvinceCode = null;
        vm.RegisterAccountViewModel_ShippingAddress_StateProvinceName = null;

        //CLEAR OTHER VALUES
        $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").val('');
        $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").val('');
        $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").val(''); 

        if ($("#RegisterAccountViewModel_ShippingAddress_CountryName option:selected").val() === 'USA') {
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").show();
            $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").hide();
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").hide();
        }
        else if ($("#RegisterAccountViewModel_ShippingAddress_CountryName option:selected").val() === 'CAN') {
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").hide();
            $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").show();
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").hide();
        }
        else {
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").hide();
            $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").hide();
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").show();
            $('#RegisterAccountViewModel_ShippingAddress_StateProvinceCode').parent().removeClass('form-error');
            $('#RegisterAccountViewModel_ShippingAddress_ProvinceCode').parent().removeClass('form-error');
            document.getElementById('ShippingStateProvinceError').innerText = "";
        }
    }

    BillingCountryChangedIndex(e) {

        var vm = this;
        vm.RegisterAccountViewModel_BillingAddress_StateProvinceCode = null;
        vm.RegisterAccountViewModel_BillingAddress_ProvinceCode = null;
        vm.RegisterAccountViewModel_BillingAddress_StateProvinceName = null;

        //CLEAR OTHER VALUES
        $("#RegisterAccountViewModel_BillingAddress_StateProvinceCode").val('');
        $("#RegisterAccountViewModel_BillingAddress_ProvinceCode").val('');
        $("#RegisterAccountViewModel_BillingAddress_StateProvinceName").val('');

        if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'USA') {
            $("#RegisterAccountViewModel_BillingAddress_StateProvinceCode").show();
            $("#RegisterAccountViewModel_BillingAddress_ProvinceCode").hide();
            $("#RegisterAccountViewModel_BillingAddress_StateProvinceName").hide();
        }
        else if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'CAN') {
            $("#RegisterAccountViewModel_BillingAddress_StateProvinceCode").hide();
            $("#RegisterAccountViewModel_BillingAddress_ProvinceCode").show();
            $("#RegisterAccountViewModel_BillingAddress_StateProvinceName").hide();
        }
        else {
            $("#RegisterAccountViewModel_BillingAddress_StateProvinceCode").hide();
            $("#RegisterAccountViewModel_BillingAddress_ProvinceCode").hide();
            $("#RegisterAccountViewModel_BillingAddress_StateProvinceName").show();
            $('#RegisterAccountViewModel_BillingAddress_StateProvinceCode').parent().removeClass('form-error');
            $('#RegisterAccountViewModel_BillingAddress_ProvinceCode').parent().removeClass('form-error');
            document.getElementById('BillingStateProvinceError').innerText = "";
        }
    }

    sameAsBillingAddress() {
        if ($('#RegisterAccountViewModel_DuplicateBilling').is(":checked")) {
            // it is checked
            $('#RegisterAccountViewModel_ShippingAddress_Line1')
                .val($("#RegisterAccountViewModel_BillingAddress_Line1").val());
            $('#RegisterAccountViewModel_ShippingAddress_Line2')
                .val($("#RegisterAccountViewModel_BillingAddress_Line2").val());
            $('#RegisterAccountViewModel_ShippingAddress_City')
                .val($("#RegisterAccountViewModel_BillingAddress_City").val());
            $('#RegisterAccountViewModel_ShippingAddress_PostalCode')
                .val($("#RegisterAccountViewModel_BillingAddress_PostalCode").val());
            $('#RegisterAccountViewModel_ShippingAddress_PhoneNumber')
                .val($("#RegisterAccountViewModel_BillingAddress_PhoneNumber").val());
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode")
                .val($("#RegisterAccountViewModel_BillingAddress_StateProvinceCode").val());
            $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode")
                .val($("#RegisterAccountViewModel_BillingAddress_ProvinceCode").val());
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName")
                .val($("#RegisterAccountViewModel_BillingAddress_StateProvinceName").val());
            $("#RegisterAccountViewModel_ShippingAddress_CountryName")
                .val($("#RegisterAccountViewModel_BillingAddress_CountryName").val());

            //to show hide correct state field
            if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'USA') {
                $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").show();
                $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").hide();
                $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").hide();
            } else if ($("#RegisterAccountViewModel_BillingAddress_CountryName option:selected").val() === 'CAN') {
                $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").hide();
                $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").show();
                $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").hide();
            } else {
                $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").hide();
                $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").hide();
                $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").show();
            }
        } else {
            //to clear as its unchecked
            $('#RegisterAccountViewModel_ShippingAddress_Line1').val('');
            $('#RegisterAccountViewModel_ShippingAddress_Line2').val('');
            $('#RegisterAccountViewModel_ShippingAddress_City').val('');
            $('#RegisterAccountViewModel_ShippingAddress_PostalCode').val('');
            $('#RegisterAccountViewModel_ShippingAddress_PhoneNumber').val('');
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").val('');
            $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").val('');
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").val('');
            $("#RegisterAccountViewModel_ShippingAddress_CountryName").val('');

            //to make sure they see default state/province state
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceCode").hide();
            $("#RegisterAccountViewModel_ShippingAddress_ProvinceCode").hide();
            $("#RegisterAccountViewModel_ShippingAddress_StateProvinceName").show();
        }
        InputFloatLabel.Rebind();
    }
}
$(document).ready(function () {
    var register = new Register();
    register.Init();
});